import { lazy, type ComponentType } from "react";

// SplitPane imports this registry with the shell. Keep app code behind the guarded mount;
// React.lazy retains resolved modules, so returning to an app does not load its bundle again.
const LibraryView = lazy(() => import("./LibraryView").then((module) => ({ default: module.LibraryView })));
const FormulatRView = lazy(() => import("@apps/formulatr/FormulatRView").then((module) => ({ default: module.FormulatRView })));
const IdeasGeneratorView = lazy(() => import("@apps/ideas-generator/IdeasGeneratorView").then((module) => ({ default: module.IdeasGeneratorView })));
const DeliverableStudioView = lazy(() => import("@apps/deliverable-studio/DeliverableStudioView").then((module) => ({ default: module.DeliverableStudioView })));
const BrainstormingView = lazy(() => import("@apps/brainstorming/BrainstormingView").then((module) => ({ default: module.BrainstormingView })));
const SemanticWorkbenchView = lazy(() => import("@apps/sentiment-workbench/SemanticWorkbenchView").then((module) => ({ default: module.SemanticWorkbenchView })));
const StudioView = lazy(() => import("@apps/studio/StudioView").then((module) => ({ default: module.StudioView })));
const CostModelingView = lazy(() => import("@apps/cost-modeling/CostModelingView").then((module) => ({ default: module.CostModelingView })));
const DesignIntelligenceView = lazy(() => import("@apps/design-intelligence/DesignIntelligenceView").then((module) => ({ default: module.DesignIntelligenceView })));
const ZarvisView = lazy(() => import("../inspector/ZarvisView").then((module) => ({ default: module.ZarvisView })));

/**
 * Native-lane sub-app components, keyed by `SubAppManifest.id`.
 *
 * A sub-app whose manifest declares `mode: "inline"` mounts its component here,
 * in-shell (the "organically built" lane). Iframe-mode apps use the iframe lane;
 * an `inline` app with no entry here (or any unknown app) falls back to the
 * honest placeholder in SubAppPage. This is the single registration point — new
 * native apps are one entry, no new route.
 */
export const INLINE_SUBAPPS: Record<string, ComponentType> = {
  library: LibraryView,
  formulatr: FormulatRView,
  "ideas-generator": IdeasGeneratorView,
  "deliverable-studio": DeliverableStudioView,
  brainstorming: BrainstormingView,
  "sentiment-workbench": SemanticWorkbenchView,
  studio: StudioView,
  "cost-modeling": CostModelingView,
  "design-intelligence": DesignIntelligenceView,
  zarvis: ZarvisView,
};
